export class ListSapSourcesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "sapSources",
            "baseName": "sapSources",
            "type": "Array<SapSource>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSapSourcesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
